import { render, staticRenderFns } from "./CreateTownForm.vue?vue&type=template&id=7ce12ff8&scoped=true"
import script from "./CreateTownForm.vue?vue&type=script&lang=js"
export * from "./CreateTownForm.vue?vue&type=script&lang=js"
import style0 from "./CreateTownForm.vue?vue&type=style&index=0&id=7ce12ff8&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7ce12ff8",
  null
  
)

export default component.exports